import { ERoleAccess } from "@/frontend/app/providers/router/config/routeConfig";
import $api from "@/frontend/shared/api/axios";

type TInviteInfo = {
  email: string;
  organizationName: string;
  investor?: {
    id: number;
    name: string;
  };
  entity?: ERoleAccess;
};

export async function getInviteTokenInfo(token: string): Promise<TInviteInfo> {
  const response = await $api.get(`/auth/invite-info/${token}`);
  return response.data.data;
}
